import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffPositionCatalogRequest,
  StaffPositionCatalogResponse,
  StaffPositionsService,
} from "lib-klab-sdks";
import { PositionCatalogPort } from "../../../app/ports/organization/position-catalog.port";
import {
  PositionCatalogItem,
  PositionCatalogRequest,
} from "../../../domain/models/organization/position-catalog.model";

@Injectable({ providedIn: "root" })
export class PositionCatalogPortAdapter implements PositionCatalogPort {
  constructor(private readonly api: StaffPositionsService) {}

  list(): Observable<PositionCatalogItem[]> {
    return this.api.list().pipe(map((items) => items.map(mapPosition)));
  }

  getById(id: number): Observable<PositionCatalogItem> {
    return this.api.getById(id).pipe(map(mapPosition));
  }

  create(request: PositionCatalogRequest): Observable<PositionCatalogItem> {
    return this.api.create(mapRequest(request)).pipe(map(mapPosition));
  }

  update(
    id: number,
    request: PositionCatalogRequest,
  ): Observable<PositionCatalogItem> {
    return this.api.update(id, mapRequest(request)).pipe(map(mapPosition));
  }

  setStatus(id: number, active: boolean): Observable<PositionCatalogItem> {
    return this.api.setStatus(id, active).pipe(map(mapPosition));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }
}

function mapPosition(
  source: StaffPositionCatalogResponse,
): PositionCatalogItem {
  return {
    id: source.id,
    companyId: null,
    departmentId: source.departmentId,
    name: source.name,
    description: null,
    requirements: null,
    salaryMin: null,
    salaryMax: null,
    status: source.active ? "ACTIVE" : "INACTIVE",
    createdAt: source.createdAt ? (source.createdAt.endsWith('Z') ? source.createdAt : source.createdAt + 'Z') : '',
    updatedAt: source.updatedAt ? (source.updatedAt.endsWith('Z') ? source.updatedAt : source.updatedAt + 'Z') : null,
  };
}

function mapRequest(
  request: PositionCatalogRequest,
): StaffPositionCatalogRequest {
  return { ...request };
}
